import { useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { UpdateItemResponse, WisaTabletHistory } from "../../../interfaces/be.interfaces";
import { getCertTabletHistory } from "../../../api/config";

import styles from "../styles.module.scss";
import moment from "moment";

const CertTabletHistory = () => {
  const { id } = useParams();

  // Fetch list of cert tablet history
  const { data: certWisaTabletsHistory } = useFetch<UpdateItemResponse<WisaTabletHistory[]>>({
    url: `${getCertTabletHistory}/${id}`,
    runOnMount: true,
  });

  return (
    <>
      <div className={styles.pageContainer}>
        <div className={`${styles.pageHeader} d-flex justify-content-between`}>
          <p>WiSA Tablet History</p>
        </div>
        <div className={styles.tableResponsive}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.center}>Customer Name</th>
                <th className={styles.center}>Assigned Date</th>
                <th className={styles.center}>Return Date</th>
              </tr>
            </thead>
            <tbody>
              {certWisaTabletsHistory?.data.map((tablet: WisaTabletHistory) => (
                <tr key={tablet.tablet_id}>
                  <td className={styles.center}>{tablet.customer?.customer_name ?? "-"}</td>
                  <td className={styles.center}>{moment(tablet.assigning_date).format("YYYY-MM-DD hh:mm A")}</td>
                  <td className={styles.center}>{tablet.return_date ? moment(tablet.return_date).format("YYYY-MM-DD hh:mm A") : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CertTabletHistory;
